module.exports = __webpack_public_path__ + "static/media/ins-5.a0b55c2c.jpg";